import React from "react";
import "@/App.css";
import "@/components/dna-mobile/DnaResponsive.css";
import "@/design-system/DnaDesignSystem.css";
import "@/design-system/DnaDialogV4.css";
import "@/design-system/DnaShadcnPolishV4.css";
import "@/design-system/dna-ds.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { isAuthenticated } from "@/lib/auth";
import { PermissoesProvider } from "@/lib/permissoes";
import { PermV2Provider } from "@/lib/perm_v2";
import Layout from "@/components/Layout";
import { ArenaTV, ArenaAluno } from "@/pages/ChampionsArena";
import HomeV3, { DnaCommandLayer, DnaSidebarV3 } from "@/pages/DnaCommandCenter";
import ListaChamadaPage from "@/pages/AcademicoRelatorios/ListaChamada";
import LivroDeClassePage from "@/pages/AcademicoRelatorios/LivroDeClasse";
import ImportarBoletos from "@/pages/DnaPay/ImportarBoletos";
import ImportarBoletosDashboard from "@/pages/DnaPay/ImportarBoletosDashboard";
import DnaPayNotificationsAdmin from "@/pages/DnaPay/DnaPayNotificationsAdmin";
import ArenaPalco from "@/pages/ArenaPalco";
import BancoDeBatalhas from "@/pages/BancoDeBatalhas";
import DnaDesignShowcase from "@/pages/DnaDesignShowcase";
import WhatsNew, { WhatsNewAutoPopup } from "@/pages/WhatsNew";
import NovosDNAsPublicLanding from "@/pages/NovosDNAs/PublicLanding";
import NovosDNAsPanel from "@/pages/NovosDNAs/Panel";
import { DataAuditStudent, DataHealthDashboard } from "@/pages/DnaDataIntegrity";
import Login from "@/pages/Login";
import NotifyRedirect from "@/pages/NotifyRedirect";
import Dashboard from "@/pages/Dashboard";
import Students from "@/pages/Students";
import Titles from "@/pages/Titles";
import ContasBancarias from "@/pages/ContasBancarias";
import Bank from "@/pages/Bank";
import Logs from "@/pages/Logs";
import Settings from "@/pages/Settings";
import FinancialAnalytics from "@/pages/FinancialAnalytics";
import ClassesManagement from "@/pages/ClassesManagement";
import TopDefaulters from "@/pages/TopDefaulters";
import Expenses from "@/pages/Expenses";
import FinancialPlans from "@/pages/FinancialPlans";
import PlanosTurma from "@/pages/DNACore2/Financeiro/PlanosTurma";
import DRECaixaIA from "@/pages/DNACore2/Financeiro/DRECaixaIA";
import ImportExport from "@/pages/ImportExport";
import Communication from "@/pages/Communication";
import Reminders from "@/pages/Reminders";
import CollectionDashboard from "@/pages/CollectionDashboard";
import AlertSettings from "@/pages/AlertSettings";
import ClassGroups from "@/pages/ClassGroups";
import Courses from "@/pages/Courses";
import Curriculums from "@/pages/Curriculums";
import Employees from "@/pages/Employees";
import TimeRecords from "@/pages/TimeRecords";
import TeacherPortal from "@/pages/TeacherPortal";
import AssessmentList from "@/pages/AssessmentEditor/AssessmentList";
import AssessmentEditor from "@/pages/AssessmentEditor/AssessmentEditor";
import TeacherAssignments from "@/pages/TeacherAssignments";
import FinancialEntries from "@/pages/FinancialEntries";
import DREPage from "@/pages/DREPage";
import RateioPage from "@/pages/RateioPage";
import BasesRateioPage from "@/pages/BasesRateioPage";
import Boletim from "@/pages/Boletim";
import Carteirinhas from "@/pages/Carteirinhas";
import Agenda from "@/pages/Agenda";
import Relatorios from "@/pages/Relatorios";
import GeracaoCobranca from "@/pages/GeracaoCobranca";
import BankIntegration from "@/pages/BankIntegration";
import ClassScheduleNew from "@/pages/ClassScheduleNew";
import FolhaPagamento from "@/pages/FolhaPagamento";
import DnaIA from "@/pages/DnaIA";
import DnaEstudosAdmin from "@/pages/DnaEstudos/DnaEstudosAdmin";
import DnaConnectEstudos from "@/pages/DnaConnect/DnaConnectEstudos";
const Rematricula2027 = React.lazy(() => import('@/pages/DnaConnect/Rematricula2027'));
const EnvioDocumentosPublico = React.lazy(() => import('@/pages/Publico/EnvioDocumentos'));
const DeclaracaoIrLote = React.lazy(() => import('@/pages/DnaPay/DeclaracaoIrLote'));
const RedefinirSenhaFamilia = React.lazy(() => import('./pages/DnaConnect/RedefinirSenha'));
const RedirectEnvioDocumentos = React.lazy(() => import('@/pages/Publico/RedirectEnvioDocumentos'));
const CentralRecuperacao = React.lazy(() => import('@/pages/Recuperacao'));
const PainelDocumentos = React.lazy(() => import('@/pages/Matriculas/CentralDocumentos'));
const PixExtrato = React.lazy(() => import('@/pages/PixExtrato'));

import AssistenteIA from "@/pages/AssistenteIA";
import Aniversariantes from "@/pages/Aniversariantes";
import CanvaRedirect from "@/pages/CanvaRedirect";
import Campanhas from "@/pages/Campanhas";
import Templates from "@/pages/Templates";
import Usuarios from "@/pages/Usuarios";
import RelatorioConsolidado from "@/pages/RelatorioConsolidado";
import Tabuada from "@/pages/Tabuada";
import QuizMilionario from "@/pages/QuizMilionario";
import Interclasse from "@/pages/Interclasse";
import TorneioProfissional from "@/pages/TorneioProfissional";
import MuralComunicados from "@/pages/MuralComunicados";
import DocumentEditor from "@/pages/DocumentEditor";
import HistoricoEscolar from "@/pages/HistoricoEscolar/HistoricoEscolar";
import HistoricoEmissoes from "@/pages/HistoricoEscolar/HistoricoEmissoes";
import EquipeLogin from "@/pages/EquipeLogin";
import EquipePortal from "@/pages/EquipePortal";
import AulasExtrasAdmin from "@/pages/AulasExtrasAdmin";
import DNACore from "@/pages/DNACore";
import { DNACoreV2 } from "@/pages/DNACoreV2";
import { CentralNotas } from "@/pages/CentralNotas";
import { RelatorioRecuperacao } from "@/pages/CentralNotas";
import { ImportTitles } from "@/pages/ImportTitles";
import { PendenciasAcademicas } from "@/pages/PendenciasAcademicas";

// DNA QUIZ LIVE - Sistema de Quiz Gamificado
import {
  QuizLiveHome,
  QuizLiveCreate,
  QuizLiveLobby,
  QuizLivePlay,
  QuizLiveHost,
  QuizLiveAI,
  QuizLiveReports
} from "@/pages/QuizLive";

// DNA PAY - Sistema Financeiro Fintech
import {
  DnaPayDashboard,
  DnaPayTitulos,
  DnaPayTituloDetalhe,
  DnaPayConciliacao,
  DnaPayRelatorios,
  DnaPayConfig,
  DnaPayGerarTitulos,
  DnaPayCobrancasAutomaticas,
  DnaPayScheduler,
  DnaPayRenegociacao,
  DnaPayMensageria,
  DnaPayRemessas,
  DnaPayRetornos,
  DnaPayFinanceHealth,
  DnaPayCobranca,
  LancamentosCentral
} from "@/pages/DnaPay";
const CentralMatriculas = React.lazy(() => import('@/pages/Matriculas/CentralMatriculas'));
const ViradaAno = React.lazy(() => import('@/pages/Matriculas/ViradaAno'));
const PainelMatriculas = React.lazy(() => import('@/pages/Matriculas/PainelMatriculas'));
const DnaSign = React.lazy(() => import('@/pages/DnaSign/DnaSign'));
const DnaSignValidar = React.lazy(() => import('@/pages/DnaSign/DnaSignValidar'));
const DnaSignStudio = React.lazy(() => import('@/pages/DnaSign/Studio/DnaSignStudio'));
const WizardRematricula = React.lazy(() => import('@/pages/Matriculas/WizardRematricula'));

// DNA Chat - Módulo institucional de mensageria
import { DnaChatApp } from "@/pages/DnaChat";

// FISCAL - Módulo de Notas Fiscais NFS-e
import FiscalDashboard from "@/pages/Fiscal/FiscalDashboard";
import FiscalConfig from "@/pages/Fiscal/FiscalConfig";
import FiscalEmpresas from "@/pages/Fiscal/FiscalEmpresas";
import FiscalImportacaoNfse from "@/pages/Fiscal/FiscalImportacaoNfse";
import FiscalEmissao from "@/pages/Fiscal/FiscalEmissao";
import FiscalNotas from "@/pages/Fiscal/FiscalNotas";
import FiscalRelatorios from "@/pages/Fiscal/FiscalRelatorios";
import FiscalIntegracao from "@/pages/Fiscal/FiscalIntegracao";
import FiscalLogs from "@/pages/Fiscal/FiscalLogs";
import FiscalErros from "@/pages/Fiscal/FiscalErros";

// TRIBUTÁRIO - Módulo de Apuração de Tributos
import {
  TributarioDashboard,
  TributarioConfig,
  TributarioApuracao,
  TributarioMemoria,
  TributarioSimulacoes,
  TributarioRelatorios,
  TributarioLogs
} from "@/pages/Tributario";

// EXECUTIVO - Dashboard Financeiro com Lucro Real
import {
  ExecutivoDashboard,
  ExecutivoDRE,
  ExecutivoSegmentos,
  ExecutivoForecast
} from "@/pages/Executivo";

// ESTRATÉGICO - Módulo de Inteligência de Negócios
import {
  ExpansaoDashboard,
  CustosDashboard
} from "@/pages/Estrategico";

// DNA GO - Módulo de Retirada Segura
import {
  DnaGoAutorizados,
  DnaGoPainelSaida,
  DnaGoPainelPorteiro,
  DnaGoRetiradas,
  DnaGoVans,
  DnaGoOcorrencias,
  DnaGoDashboard
} from "@/pages/DnaGo";

// DNA CONNECT - Portal das Famílias
import {
  DnaConnectLayout,
  DnaConnectLogin,
  DnaConnectDashboard,
  DnaConnectFilhos,
  DnaConnectPedagogico,
  DnaConnectComunicacao,
  DnaConnectCalendario,
  DnaConnectDocumentos,
  DnaConnectDnaGo,
  DnaConnectPerfil,
  DnaConnectTrocarSenha,
  DnaConnectCarteirinha
} from "@/pages/DnaConnect";

// DNA CONNECT - Portal Financeiro (DNA Pay)
import DnaConnectFinanceiroPortal from "@/pages/DnaConnect/DnaConnectFinanceiroPortal";
import DnaConnectConvites, { DnaConnectEventos } from "@/pages/DnaConnect/DnaConnectConvites";

// DNA CONNECT - Aulas Extras
import AulasExtras from "@/pages/DnaConnect/AulasExtras";

// DNA CONNECT - Semana de Avaliações
import DnaConnectSemanaAvaliacoes from "@/pages/DnaConnect/DnaConnectSemanaAvaliacoes";

// DNA CONNECT - Área Administrativa
import DnaConnectAdmin from "@/pages/DnaConnectAdmin";

// DNA GROWTH ENGINE
import { DnaCRM, DnaGrowthDashboard, DnaSocialAI, DnaAtendimentoAI, DnaAdsAI, DnaFunnelAI, DnaWhatsAppAI, DnaGrowthAI, DnaReputationAI } from "@/pages/GrowthEngine";

// CALENDÁRIO ESCOLAR
import CalendarioEscolarAdmin from "@/pages/CalendarioEscolarAdmin";
import CalendarioEscolarPublico from "@/pages/CalendarioEscolarPublico";

// AGENTE IA DE SEMANA DE AVALIAÇÕES
import { AssessmentWeek } from "@/pages/AssessmentWeek";
import AssessmentPrintReportPage from "@/pages/AssessmentWeek/AssessmentPrintReportPage";

// DNACORE 2.0 - Nova Versão Premium
import {
  Layout2,
  Dashboard2,
  Aluno360,
  CentralOperacional,
  Academico,
  Financeiro360,
  Comunicacao,
  RelatoriosIA,
  Configuracoes
} from "@/pages/DNACore2";
import CadastrosIncompletos from "@/pages/DNACore2/CadastrosIncompletos";
import PedidoCadastroFamilia from "@/pages/PedidoCadastroFamilia";

// PORTAL GESTÃO DNA (V4.50)
import GestaoLayout from "@/pages/PortalGestao/GestaoLayout";
import GestaoHome from "@/pages/PortalGestao/GestaoHome";
import GestaoResponsaveis from "@/pages/PortalGestao/GestaoResponsaveis";
import GestaoTurmas from "@/pages/PortalGestao/GestaoTurmas";
import GestaoOcorrencias from "@/pages/PortalGestao/GestaoOcorrencias";
import PortalGestaoAlertas from "@/pages/PortalGestao/PortalGestaoAlertas";
import PortalGestaoRegras from "@/pages/PortalGestao/PortalGestaoRegras";
import WhatsAppConfigPanel from "@/pages/DnaChat/WhatsAppConfigPanel";
import WhatsAppQueuePanel from "@/pages/DnaChat/WhatsAppQueuePanel";
import WhatsAppTemplatesPanel from "@/pages/DnaChat/WhatsAppTemplatesPanel";
import WhatsAppFailuresPanel from "@/pages/DnaChat/WhatsAppFailuresPanel";

// DNA INFANTIL 360 IA
import Infantil360Shell from "@/modules/infantil360/layout/Infantil360Shell";
import InfantilDashboardPage from "@/modules/infantil360/dashboard/InfantilDashboardPage";
import ObservationsListPage from "@/modules/infantil360/observations/ObservationsListPage";
import NewObservationPage from "@/modules/infantil360/observations/NewObservationPage";
import Student360Page from "@/modules/infantil360/students/Student360Page";
import ClassOverviewPage from "@/modules/infantil360/classes/ClassOverviewPage";
import PortfolioBuilderPage from "@/modules/infantil360/portfolios/PortfolioBuilderPage";
import ReportEditorPage from "@/modules/infantil360/reports/ReportEditorPage";
import PlanningPage from "@/modules/infantil360/planning/PlanningPage";
import CoordinationDashboardPage from "@/modules/infantil360/coordination/CoordinationDashboardPage";
import FamilyPublishPage from "@/modules/infantil360/family/FamilyPublishPage";
import PlaceholderPage from "@/modules/infantil360/shared/PlaceholderPage";

// FESTA JUNINA 2026 — Convite Virtual
import EventoCentral from "@/pages/Eventos/EventoCentral";
import AcervoSponte from "@/pages/AcervoSponte/AcervoSponte";
import DnaMapa from "@/pages/DnaMapa/DnaMapa";
import AutorizacaoEventoPublica from "@/pages/Eventos/AutorizacaoEventoPublica";
import { FestaJuninaAdminPanel, FestaJuninaCheckin, FestaJuninaConvite, FestaJuninaImprimir, FestaJuninaVendas, FestaJuninaEventos, FestaJuninaSorteio } from "@/pages/FestaJunina/FestaJunina";

// Permissões V2
import PermissoesV2 from "@/pages/Admin/PermissoesV2";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <Layout>{children}</Layout>;
};

// V1→V2 redirect que preserva o :id da rota legada /financeiro/titulos/:id
const DnaPayTituloDetalheRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/v2/financeiro/dnapay/titulos/${id}`} replace />;
};

// Link público do boleto (token opaco) → entrega o PDF real, sem login
const PublicBoletoRedirect = () => {
  const { token } = useParams();
  React.useEffect(() => {
    window.location.replace(`${process.env.REACT_APP_BACKEND_URL}/api/public/boleto/${token}`);
  }, [token]);
  return <div style={{ padding: 40, fontFamily: 'system-ui', textAlign: 'center' }}>Abrindo boleto…</div>;
};


// Protected Route for Equipe Portal (no sidebar layout)
// Gestão DNA: guard avaliado no render (evita element "stale" logo após o login)
const RequireAuthGestao = ({ children }) =>
  isAuthenticated() ? children : <Navigate to="/login" replace />;

const ProtectedEquipeRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/equipe" replace />;
  }
  return children;
};

// Protected Equipe Portal with redirect to Teacher Portal for teachers
const EquipePortalWrapper = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const userRole = user?.role?.toLowerCase();
  const isTeacher = userRole === 'teacher' || userRole === 'professor';
  const isAdminUser = userRole === 'admin';
  const isCoordOrSecretary = userRole === 'coordenacao' || userRole === 'secretaria';
  
  // Teachers, Admins, Coordenação e Secretaria vão para o TeacherPortal completo
  if (isTeacher || isAdminUser || isCoordOrSecretary) {
    return <TeacherPortal equipeMode={true} />;
  }
  
  // Other employees go to simplified EquipePortal
  return <EquipePortal />;
};

function App() {
  return (
    <div className="App notranslate" translate="no">
      <BrowserRouter>
        <PermissoesProvider>
        <PermV2Provider>
        <WhatsNewAutoPopup />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/pedido-cadastro/:token" element={<PedidoCadastroFamilia />} />

          {/* GESTÃO DNA (/gestao) — portal pedagógico/secretaria · SEM financeiro */}
          <Route
            path="/gestao"
            element={<RequireAuthGestao><GestaoLayout /></RequireAuthGestao>}
          >
            <Route index element={<GestaoHome />} />
            <Route path="alunos" element={<Aluno360 />} />
            <Route path="alunos/:alunoId" element={<Aluno360 />} />
            <Route path="responsaveis" element={<GestaoResponsaveis />} />
            <Route path="notas" element={<CentralNotas />} />
            <Route path="turmas" element={<GestaoTurmas />} />
            <Route path="ocorrencias" element={<GestaoOcorrencias />} />
            <Route path="recuperacao" element={<RelatorioRecuperacao year={new Date().getFullYear()} filtros={{}} />} />
            <Route path="historico" element={<HistoricoEscolar />} />
            <Route path="historico/:studentId" element={<HistoricoEscolar />} />
            <Route path="documentos" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><DnaSign /></React.Suspense>} />
            <Route path="documentos/:tab" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><DnaSign /></React.Suspense>} />
            <Route path="calendario" element={<CalendarioEscolarAdmin />} />
            <Route path="dnago" element={<DnaGoDashboard />} />
            <Route path="dna-mapa" element={<DnaMapa />} />
            <Route path="alertas" element={<PortalGestaoAlertas />} />
            <Route path="regras" element={<PortalGestaoRegras />} />
            <Route path="acervo-sponte" element={<AcervoSponte />} />
          </Route>

          {/* Rota legada do Portal Gestão → Gestão DNA */}
          <Route path="/portal-gestao" element={<Navigate to="/gestao" replace />} />
          <Route path="/portal-gestao/*" element={<Navigate to="/gestao" replace />} />

          {/* Magic-link público (rastreia abertura de e-mail) */}
          <Route path="/notify/:lembreteId" element={<NotifyRedirect />} />
          {/* Portal da Equipe - Rotas específicas */}
          <Route path="/equipe" element={<EquipeLogin />} />
          <Route path="/equipe/dna-mapa" element={<ProtectedEquipeRoute><div className="min-h-screen bg-[#FBF9FD]"><DnaMapa /></div></ProtectedEquipeRoute>} />
          <Route 
            path="/equipe/portal" 
            element={
              <ProtectedEquipeRoute>
                <EquipePortalWrapper />
              </ProtectedEquipeRoute>
            } 
          />
          <Route
            path="/equipe/avaliacoes/editor"
            element={
              <ProtectedEquipeRoute>
                <AssessmentList basePath="/equipe/avaliacoes/editor" />
              </ProtectedEquipeRoute>
            }
          />
          <Route
            path="/equipe/avaliacoes/editor/:id"
            element={
              <ProtectedEquipeRoute>
                <AssessmentEditor />
              </ProtectedEquipeRoute>
            }
          />
          <Route
            path="/"
            element={
              isAuthenticated() ? (
                <Navigate to="/v2/dashboard" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/dashboard"
            element={<Navigate to="/v2/dashboard" replace />}
          />
          <Route
            path="/dnacore"
            element={
              <ProtectedRoute>
                <DNACore />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dnacore/evolucao"
            element={
              <ProtectedRoute>
                <DNACoreV2 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dnacore-v2"
            element={<Navigate to="/v2/dashboard" replace />}
          />
          <Route
            path="/central-notas"
            element={<Navigate to="/v2/academico/notas" replace />}
          />
          <Route
            path="/central-notas/pendencias"
            element={<Navigate to="/v2/academico/pendencias" replace />}
          />

          {/* Acadêmico → Relatórios → Lista de Chamada */}
          <Route
            path="/v2/academico/relatorios/lista-chamada"
            element={isAuthenticated() ? <ListaChamadaPage /> : <Navigate to="/login" replace />}
          />
          {/* Acadêmico → Relatórios → Livro de Classe Premium (V4.18) */}
          <Route
            path="/v2/academico/relatorios/livro-de-classe"
            element={isAuthenticated() ? <LivroDeClassePage /> : <Navigate to="/login" replace />}
          />

          {/* Desafio dos Campeões — Banco de Batalhas (acesso rápido) */}
          <Route
            path="/v2/desafio-campeoes"
            element={isAuthenticated() ? <BancoDeBatalhas /> : <Navigate to="/login" replace />}
          />

          {/* DNACore V4 — Design System Showcase (validação visual da Onda 1) */}
          <Route path="/v4/design" element={<DnaDesignShowcase />} />
          <Route path="/o-que-ha-de-novo" element={<WhatsNew />} />

          {/* Boleto por token opaco — abre o PDF sem sessão administrativa */}
          <Route path="/boleto/:token" element={<PublicBoletoRedirect />} />
          {/* NOVOS DNAs — Landing pública de captação (sem auth) */}
          <Route path="/conheca-o-novo-dna" element={<NovosDNAsPublicLanding />} />
          <Route path="/novosdnas" element={<NovosDNAsPublicLanding />} />
          {/* Domínio dedicado novosdnas.novodna.com.br → landing na raiz */}
          {window.location.hostname.startsWith("novosdnas.") && (
            <Route path="/" element={<NovosDNAsPublicLanding />} />
          )}
          
          {/* AGENTE IA DE SEMANA DE AVALIAÇÕES */}
          <Route
            path="/semana-avaliacoes"
            element={
              <ProtectedRoute>
                <AssessmentWeek />
              </ProtectedRoute>
            }
          />
          <Route
            path="/semana-avaliacoes/relatorio-impressao"
            element={
              <ProtectedRoute>
                <AssessmentPrintReportPage />
              </ProtectedRoute>
            }
          />

          {/* FESTA JUNINA 2026 — Convite Virtual */}
          <Route path="/festa-junina" element={<ProtectedRoute><FestaJuninaAdminPanel /></ProtectedRoute>} />
          <Route path="/festa-junina/imprimir" element={isAuthenticated() ? <FestaJuninaImprimir /> : <Navigate to="/login" replace />} />
          <Route path="/festa-junina/convite/:numero" element={isAuthenticated() ? <FestaJuninaConvite /> : <Navigate to="/login" replace />} />
          <Route path="/festa-junina/checkin" element={isAuthenticated() ? <FestaJuninaCheckin /> : <Navigate to="/login" replace />} />
          <Route path="/festa-junina/checkin/:token" element={isAuthenticated() ? <FestaJuninaCheckin /> : <Navigate to="/login" replace />} />
          
          {/* ======================================== */}
          {/* DNACORE 2.0 - PLATAFORMA UNIFICADA PREMIUM */}
          {/* ======================================== */}
          {/* Festa Junina · Portaria (FULLSCREEN, SEM Layout2/sidebar) */}
          <Route path="/v2/festa-junina/checkin" element={isAuthenticated() ? <FestaJuninaCheckin /> : <Navigate to="/login" replace />} />
          <Route path="/v2/festa-junina/checkin/:token" element={isAuthenticated() ? <FestaJuninaCheckin /> : <Navigate to="/login" replace />} />

          {/* Arena Ao Vivo · Desafio dos Campeões (FULLSCREEN, sem sidebar) */}
          <Route path="/arena/:code" element={<ArenaTV />} />
          <Route path="/arena/aluno/:code" element={<ArenaAluno />} />
          <Route path="/arena/palco/:code" element={<ArenaPalco />} />

          {/* DNACore V3 — Home Premium (Hoje no Novo DNA) */}
          <Route path="/v3" element={isAuthenticated() ? <HomeV3 /> : <Navigate to="/login" replace />} />

          {/* DNACore V3.5 — Sidebar Iconic Preview (lado a lado da HomeV3) */}
          <Route path="/v3/sidebar" element={isAuthenticated() ? (
            <div style={{ display: 'flex', minHeight: '100vh', background: '#06070b' }}>
              <DnaSidebarV3 />
              <div style={{ flex: 1 }}><HomeV3 /></div>
            </div>
          ) : <Navigate to="/login" replace />} />

          {/* DNACore V4 — Data Integrity (read-only audit) */}
          <Route path="/v4/health" element={isAuthenticated() ? <DataHealthDashboard /> : <Navigate to="/login" replace />} />
          <Route path="/v4/audit/:id" element={isAuthenticated() ? <DataAuditStudent /> : <Navigate to="/login" replace />} />

          <Route path="/autorizacao-evento/:token" element={<AutorizacaoEventoPublica />} />
          <Route path="/v2" element={<Layout2 />}>
            <Route index element={<Navigate to="/v2/dashboard" replace />} />

            {/* FESTA JUNINA 2026 — dentro do V2 (com sidebar) */}
            <Route path="festa-junina" element={<FestaJuninaVendas />} />
            <Route path="festa-junina/sorteio" element={<FestaJuninaSorteio />} />
            <Route path="festa-junina/eventos" element={<FestaJuninaEventos />} />
            <Route path="eventos" element={<FestaJuninaEventos />} />
            <Route path="eventos/:id" element={<EventoCentral />} />
            <Route path="acervo-sponte" element={<AcervoSponte />} />
            <Route path="pedagogico/dna-mapa" element={<DnaMapa />} />
            <Route path="festa-junina/admin" element={<FestaJuninaAdminPanel />} />
            <Route path="festa-junina/convite/:numero" element={<FestaJuninaConvite />} />
            <Route path="festa-junina/imprimir" element={<FestaJuninaImprimir />} />

            {/* PERMISSÕES V2 — gestão granular */}
            <Route path="permissoes-v2" element={<PermissoesV2 />} />

            {/* 1. DASHBOARD */}
            <Route path="dashboard" element={<Dashboard2 />} />

            {/* 2. CENTRAL OPERACIONAL */}
            <Route path="central" element={<CentralOperacional />} />

            {/* 3. ALUNO 360 */}
            <Route path="aluno" element={<Aluno360 />} />
            <Route path="aluno/:alunoId" element={<Aluno360 />} />
            <Route path="alunos/cadastros-incompletos" element={<CadastrosIncompletos />} />

            {/* 4. ACADÊMICO - Shell + Páginas Reais */}
            <Route path="academico" element={<Academico />} />
            <Route path="academico/turmas" element={<ClassesManagement />} />
            <Route path="academico/agrupamentos" element={<ClassGroups />} />
            <Route path="academico/cursos" element={<Courses />} />
            <Route path="academico/matrizes" element={<Curriculums />} />
            <Route path="academico/horarios" element={<ClassScheduleNew />} />
            <Route path="academico/professores" element={<TeacherAssignments />} />
            <Route path="academico/portal-professor" element={<TeacherPortal />} />
            <Route path="academico/notas" element={<CentralNotas />} />
            <Route path="academico/pendencias" element={<PendenciasAcademicas />} />
            <Route path="academico/boletim" element={<Boletim />} />
            <Route path="academico/dna-estudos" element={<DnaEstudosAdmin />} />
            <Route path="academico/agenda" element={<Agenda />} />
            <Route path="academico/calendario" element={<CalendarioEscolarAdmin />} />
            <Route path="academico/avaliacoes" element={<AssessmentWeek />} />
            <Route path="academico/editor-avaliacoes" element={<AssessmentList basePath="/v2/academico/editor-avaliacoes" />} />
            <Route path="academico/editor-avaliacoes/:id" element={<AssessmentEditor />} />
            <Route path="academico/carteirinhas" element={<Carteirinhas />} />
            <Route path="academico/documentos" element={<DocumentEditor />} />

            {/* SECRETARIA - Histórico Escolar EM */}
            <Route path="secretaria/historico" element={<HistoricoEscolar />} />
            <Route path="secretaria/historico/emissoes" element={<HistoricoEmissoes />} />
            <Route path="secretaria/historico/:studentId" element={<HistoricoEscolar />} />

            {/* V4.12/V4.13 obsoleto — Dashboard/Fila da Secretaria foi consolidado no Relatório de Impressão da Semana de Avaliações */}
            <Route path="secretaria/dashboard" element={<Navigate to="/semana-avaliacoes/relatorio-impressao" replace />} />
            <Route path="secretaria/fila-impressao" element={<Navigate to="/semana-avaliacoes/relatorio-impressao" replace />} />

            {/* NOVOS DNAs — Painel CRM da Secretaria */}
            <Route path="secretaria/novos-dnas" element={<NovosDNAsPanel />} />

            {/* 5. FINANCEIRO 360 - Shell + Páginas Reais */}
            <Route path="financeiro" element={<Financeiro360 />} />
            <Route path="financeiro/dnapay" element={<DnaPayDashboard />} />
            <Route path="financeiro/dnapay/titulos" element={<DnaPayTitulos />} />
            <Route path="financeiro/dnapay/declaracao-ir" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><DeclaracaoIrLote /></React.Suspense>} />
            <Route path="financeiro/dnapay/titulos/:id" element={<DnaPayTituloDetalhe />} />
            {/* V4.20 — Importação de boletos Safra */}
            <Route path="financeiro/dnapay/importar-boletos" element={<ImportarBoletos />} />
            <Route path="financeiro/dnapay/importar-boletos/dashboard" element={<ImportarBoletosDashboard />} />
            {/* V4.42 — Notificações Financeiras (motor + templates) */}
            <Route path="financeiro/dnapay/notificacoes" element={<DnaPayNotificationsAdmin />} />
            <Route path="financeiro/dnapay/remessas" element={<DnaPayRemessas />} />
            <Route path="financeiro/dnapay/pix-extrato" element={<React.Suspense fallback={<div className="p-8">Carregando...</div>}><PixExtrato /></React.Suspense>} />
            <Route path="financeiro/dnapay/retornos" element={<DnaPayRetornos />} />
            <Route path="financeiro/dnapay/saude" element={<DnaPayFinanceHealth />} />
            <Route path="financeiro/central-lancamentos" element={<LancamentosCentral />} />
            <Route path="financeiro/dnapay/central-lancamentos" element={<LancamentosCentral />} />
            <Route path="matriculas" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><CentralMatriculas /></React.Suspense>} />
            <Route path="matriculas/virada-ano" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><ViradaAno /></React.Suspense>} />
            <Route path="matriculas/painel" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><PainelMatriculas /></React.Suspense>} />
            <Route path="matriculas/documentos" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><PainelDocumentos /></React.Suspense>} />
            <Route path="dna-sign" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><DnaSign /></React.Suspense>} />
            <Route path="dna-sign/modelos/novo" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><DnaSignStudio /></React.Suspense>} />
            <Route path="dna-sign/modelos/:id/editar" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><DnaSignStudio /></React.Suspense>} />
            <Route path="dna-sign/:tab" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><DnaSign /></React.Suspense>} />

            <Route path="matriculas/wizard/:pid" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><WizardRematricula /></React.Suspense>} />
            <Route path="financeiro/titulos" element={<Titles />} />
            <Route path="financeiro/gerar-titulos" element={<DnaPayGerarTitulos />} />
            <Route path="financeiro/importar" element={<ImportTitles />} />
            {/* PATCH: V1 redirecionado para V2 */}
            <Route path="financeiro/cobranca" element={<Navigate to="/v2/financeiro/dnapay/remessas" replace />} />
            <Route path="financeiro/integracao-bancaria" element={<Navigate to="/v2/financeiro/config" replace />} />
            <Route path="financeiro/cobrancas-auto" element={<DnaPayCobrancasAutomaticas />} />
            <Route path="financeiro/conciliacao" element={<DnaPayConciliacao />} />
            <Route path="financeiro/contas" element={<ContasBancarias />} />
            <Route path="financeiro/planos" element={<FinancialPlans />} />
            <Route path="financeiro/planos-turma" element={<PlanosTurma />} />
            <Route path="financeiro/dre-caixa-ia" element={<DRECaixaIA />} />
            <Route path="financeiro/despesas" element={<Expenses />} />
            <Route path="financeiro/lancamentos" element={<FinancialEntries />} />
            <Route path="financeiro/dre" element={<DREPage />} />
            <Route path="financeiro/rateio" element={<RateioPage />} />
            <Route path="financeiro/bases-rateio" element={<BasesRateioPage />} />
            <Route path="financeiro/inadimplentes" element={<TopDefaulters />} />
            <Route path="financeiro/cobranca-dashboard" element={<CollectionDashboard />} />
            <Route path="financeiro/relatorios" element={<DnaPayRelatorios />} />
            <Route path="financeiro/analytics" element={<FinancialAnalytics />} />
            <Route path="financeiro/renegociacao" element={<DnaPayRenegociacao />} />
            <Route path="financeiro/cobranca-extrajudicial" element={<DnaPayCobranca />} />
            <Route path="financeiro/central-recuperacao" element={<React.Suspense fallback={<div className="p-8 text-sm text-slate-500">Carregando…</div>}><CentralRecuperacao /></React.Suspense>} />
            <Route path="chat" element={<DnaChatApp />} />
            <Route path="chat/whatsapp/config" element={<WhatsAppConfigPanel />} />
            <Route path="chat/whatsapp/queue" element={<WhatsAppQueuePanel />} />
            <Route path="chat/whatsapp/templates" element={<WhatsAppTemplatesPanel />} />
            <Route path="chat/whatsapp/failures" element={<WhatsAppFailuresPanel />} />
            <Route path="financeiro/mensageria" element={<DnaPayMensageria />} />
            <Route path="financeiro/scheduler" element={<DnaPayScheduler />} />
            <Route path="financeiro/folha" element={<FolhaPagamento />} />
            <Route path="financeiro/config" element={<DnaPayConfig />} />
            <Route path="financeiro/fiscal" element={<FiscalDashboard />} />
            <Route path="financeiro/fiscal/config" element={<FiscalConfig />} />
            <Route path="financeiro/fiscal/emissao" element={<FiscalEmissao />} />
            <Route path="financeiro/fiscal/notas" element={<FiscalNotas />} />
            <Route path="financeiro/fiscal/relatorios" element={<FiscalRelatorios />} />
            <Route path="financeiro/fiscal/integracao" element={<FiscalIntegracao />} />
            <Route path="financeiro/fiscal/logs" element={<FiscalLogs />} />
            <Route path="financeiro/fiscal/erros" element={<FiscalErros />} />
            <Route path="financeiro/tributario" element={<TributarioDashboard />} />
            <Route path="financeiro/tributario/config" element={<TributarioConfig />} />
            <Route path="financeiro/tributario/apuracao" element={<TributarioApuracao />} />
            <Route path="financeiro/tributario/memoria" element={<TributarioMemoria />} />
            <Route path="financeiro/tributario/simulacoes" element={<TributarioSimulacoes />} />
            <Route path="financeiro/tributario/relatorios" element={<TributarioRelatorios />} />
            <Route path="financeiro/tributario/logs" element={<TributarioLogs />} />
            <Route path="financeiro/executivo" element={<ExecutivoDashboard />} />
            <Route path="financeiro/executivo/dre" element={<ExecutivoDRE />} />
            <Route path="financeiro/executivo/segmentos" element={<ExecutivoSegmentos />} />
            <Route path="financeiro/executivo/forecast" element={<ExecutivoForecast />} />

            {/* 6. COMUNICAÇÃO - Shell + Páginas Reais */}
            <Route path="comunicacao" element={<Comunicacao />} />
            <Route path="comunicacao/mensagens" element={<Communication />} />
            <Route path="comunicacao/mural" element={<MuralComunicados />} />
            <Route path="comunicacao/campanhas" element={<Campanhas />} />
            <Route path="comunicacao/templates" element={<Templates />} />
            <Route path="comunicacao/lembretes" element={<Reminders />} />
            <Route path="comunicacao/alertas" element={<AlertSettings />} />
            <Route path="comunicacao/aniversariantes" element={<Aniversariantes />} />

            {/* 7. OPERAÇÃO (DNA GO) - Páginas Reais */}
            <Route path="operacao" element={<DnaGoDashboard />} />
            <Route path="operacao/painel" element={<DnaGoPainelSaida />} />
            <Route path="operacao/portaria" element={<DnaGoPainelPorteiro />} />
            <Route path="operacao/autorizados" element={<DnaGoAutorizados />} />
            <Route path="operacao/retiradas" element={<DnaGoRetiradas />} />
            <Route path="operacao/vans" element={<DnaGoVans />} />
            <Route path="operacao/ocorrencias" element={<DnaGoOcorrencias />} />

            {/* 8. FAMÍLIA (DNA CONNECT) - Admin */}
            <Route path="familia/admin" element={<DnaConnectAdmin />} />
            <Route path="familia/aulas-extras" element={<AulasExtrasAdmin />} />

            {/* 9. IA (DNA IA) - Páginas Reais */}
            <Route path="ia" element={<DnaIA />} />
            <Route path="ia/assistente" element={<AssistenteIA />} />
            <Route path="ia/fluencia" element={<DnaIA />} />
            <Route path="ia/tabuada" element={<Tabuada />} />
            <Route path="ia/quiz" element={<QuizMilionario />} />
            <Route path="ia/quiz-live" element={<QuizLiveHome />} />
            <Route path="ia/quiz-live/criar" element={<QuizLiveCreate />} />
            <Route path="ia/quiz-live/ai" element={<QuizLiveAI />} />
            <Route path="ia/quiz-live/relatorios" element={<QuizLiveReports />} />
            <Route path="ia/interclasse" element={<Interclasse />} />
            <Route path="ia/torneio" element={<TorneioProfissional />} />

            {/* 10. GROWTH ENGINE - Páginas Reais */}
            <Route path="growth" element={<DnaGrowthDashboard />} />
            <Route path="growth/crm" element={<DnaCRM />} />
            <Route path="growth/social" element={<DnaSocialAI />} />
            <Route path="growth/atendimento" element={<DnaAtendimentoAI />} />
            <Route path="growth/ads" element={<DnaAdsAI />} />
            <Route path="growth/funnel" element={<DnaFunnelAI />} />
            <Route path="growth/whatsapp" element={<DnaWhatsAppAI />} />
            <Route path="growth/analytics" element={<DnaGrowthAI />} />
            <Route path="growth/reputation" element={<DnaReputationAI />} />

            {/* 11. RELATÓRIOS & INTELIGÊNCIA */}
            <Route path="relatorios" element={<RelatoriosIA />} />
            <Route path="relatorios/geral" element={<Relatorios />} />
            <Route path="relatorios/consolidado" element={<RelatorioConsolidado />} />
            <Route path="relatorios/expansao" element={<ExpansaoDashboard />} />
            <Route path="relatorios/custos" element={<CustosDashboard />} />

            {/* CONFIGURAÇÕES */}
            <Route path="configuracoes" element={<Configuracoes />} />
            <Route path="configuracoes/usuarios" element={<Usuarios />} />
            <Route path="configuracoes/equipe" element={<Employees />} />
            <Route path="configuracoes/ponto" element={<TimeRecords />} />
            <Route path="configuracoes/importar" element={<ImportExport />} />
            <Route path="configuracoes/logs" element={<Logs />} />
            <Route path="configuracoes/sistema" element={<Settings />} />
          </Route>

          {/* ======================================== */}
          {/* DNA INFANTIL 360 IA */}
          {/* ======================================== */}
          <Route path="/v2/infantil" element={<Infantil360Shell />}>
            <Route index element={<InfantilDashboardPage />} />
            <Route path="observacoes" element={<ObservationsListPage />} />
            <Route path="novo-registro" element={<NewObservationPage />} />
            <Route path="crianca" element={<Student360Page />} />
            <Route path="crianca/:studentId" element={<Student360Page />} />
            <Route path="turma" element={<ClassOverviewPage />} />
            <Route path="portfolios" element={<PortfolioBuilderPage />} />
            <Route path="relatorios" element={<ReportEditorPage />} />
            <Route path="planejamento" element={<PlanningPage />} />
            <Route path="coordenacao" element={<CoordinationDashboardPage />} />
            <Route path="familia" element={<FamilyPublishPage />} />
          </Route>
          
          {/* Central de Importação de Títulos Financeiros */}
          <Route
            path="/finance/import-titles"
            element={
              <ProtectedRoute>
                <ImportTitles />
              </ProtectedRoute>
            }
          />
          
          {/* DNA QUIZ LIVE - Sistema de Quiz Gamificado */}
          <Route
            path="/quiz-live"
            element={
              <ProtectedRoute>
                <QuizLiveHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz-live/criar"
            element={
              <ProtectedRoute>
                <QuizLiveCreate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz-live/editar/:quizId"
            element={
              <ProtectedRoute>
                <QuizLiveCreate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz-live/lobby/:sessionCode"
            element={
              <ProtectedRoute>
                <QuizLiveLobby />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz-live/host/:sessionCode"
            element={
              <ProtectedRoute>
                <QuizLiveHost />
              </ProtectedRoute>
            }
          />
          {/* Rota pública para alunos jogarem */}
          <Route path="/quiz-live/jogar/:sessionCode" element={<QuizLivePlay />} />
          <Route
            path="/quiz-live/ai"
            element={
              <ProtectedRoute>
                <QuizLiveAI />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz-live/relatorios"
            element={
              <ProtectedRoute>
                <QuizLiveReports />
              </ProtectedRoute>
            }
          />

          {/* ════════════════════════════════════════════════════════════
              DNACore V1 LEGACY ROUTES — redirect to V2 equivalents
              REGRA: V1 = legado. V2 = fonte oficial para novas features.
              Não adicionar novas rotas/funcionalidades aqui.
              ════════════════════════════════════════════════════════════ */}

          {/* DNA PAY V1 → V2 (financeiro) */}
          <Route path="/financeiro" element={<Navigate to="/v2/financeiro/dnapay" replace />} />
          <Route path="/financeiro/titulos" element={<Navigate to="/v2/financeiro/dnapay/titulos" replace />} />
          <Route path="/financeiro/titulos/:id" element={<DnaPayTituloDetalheRedirect />} />
          <Route path="/financeiro/conciliacao" element={<Navigate to="/v2/financeiro/conciliacao" replace />} />
          <Route path="/financeiro/relatorios" element={<Navigate to="/v2/financeiro/relatorios" replace />} />
          <Route path="/financeiro/config" element={<Navigate to="/v2/financeiro/config" replace />} />
          <Route path="/dnapay/gerar-titulos" element={<Navigate to="/v2/financeiro/gerar-titulos" replace />} />
          <Route path="/dnapay/cobrancas-automaticas" element={<Navigate to="/v2/financeiro/cobrancas-auto" replace />} />
          <Route path="/dnapay/scheduler" element={<Navigate to="/v2/financeiro/scheduler" replace />} />
          <Route path="/dnapay/renegociacao" element={<Navigate to="/v2/financeiro/renegociacao" replace />} />
          <Route path="/dnapay/mensageria" element={<Navigate to="/v2/financeiro/mensageria" replace />} />

          {/* Demais rotas V1 com equivalente V2 — redirect */}
          <Route path="/students" element={<Navigate to="/v2/aluno" replace />} />
          <Route path="/titles" element={<Navigate to="/v2/financeiro/titulos" replace />} />
          <Route path="/contas-bancarias" element={<Navigate to="/v2/financeiro/contas" replace />} />
          <Route path="/geracao-cobranca" element={<Navigate to="/v2/financeiro/cobranca" replace />} />
          <Route path="/integracao-bancaria" element={<Navigate to="/v2/financeiro/integracao-bancaria" replace />} />
          <Route path="/analytics" element={<Navigate to="/v2/financeiro/analytics" replace />} />
          <Route path="/classes" element={<Navigate to="/v2/academico/turmas" replace />} />
          <Route path="/defaulters" element={<Navigate to="/v2/financeiro/inadimplentes" replace />} />
          <Route path="/expenses" element={<Navigate to="/v2/financeiro/despesas" replace />} />
          <Route path="/financial-plans" element={<Navigate to="/v2/financeiro/planos" replace />} />
          <Route path="/import-export" element={<Navigate to="/v2/configuracoes/importar" replace />} />
          <Route path="/collection" element={<Navigate to="/v2/financeiro/cobranca-dashboard" replace />} />
          <Route path="/class-groups" element={<Navigate to="/v2/academico/agrupamentos" replace />} />
          <Route path="/courses" element={<Navigate to="/v2/academico/cursos" replace />} />
          <Route path="/curriculums" element={<Navigate to="/v2/academico/matrizes" replace />} />
          <Route path="/employees" element={<Navigate to="/v2/configuracoes/equipe" replace />} />
          <Route path="/time-records" element={<Navigate to="/v2/configuracoes/ponto" replace />} />
          <Route path="/teacher-portal" element={<Navigate to="/v2/academico/portal-professor" replace />} />
          <Route path="/teacher-assignments" element={<Navigate to="/v2/academico/professores" replace />} />
          <Route path="/class-schedule" element={<Navigate to="/v2/academico/horarios" replace />} />
          <Route path="/folha-pagamento" element={<Navigate to="/v2/financeiro/folha" replace />} />
          <Route path="/financial-entries" element={<Navigate to="/v2/financeiro/lancamentos" replace />} />
          <Route path="/dre" element={<Navigate to="/v2/financeiro/dre" replace />} />
          <Route path="/rateio" element={<Navigate to="/v2/financeiro/rateio" replace />} />
          <Route path="/bases-rateio" element={<Navigate to="/v2/financeiro/bases-rateio" replace />} />
          <Route path="/boletim" element={<Navigate to="/v2/academico/boletim" replace />} />
          <Route path="/carteirinhas" element={<Navigate to="/v2/academico/carteirinhas" replace />} />
          <Route path="/agenda" element={<Navigate to="/v2/academico/agenda" replace />} />
          <Route path="/relatorios" element={<Navigate to="/v2/relatorios/geral" replace />} />
          <Route path="/finance/import-titles" element={<Navigate to="/v2/financeiro/importar" replace />} />

          {/* ════════════════════════════════════════════════════════════
              FIM DOS REDIRECTS V1 → V2
              ════════════════════════════════════════════════════════════ */}

          {/* Rotas V1 sem equivalente V2 (mantidas como legado, sem novas features) */}
          <Route
            path="/bank"
            element={
              <ProtectedRoute>
                <Bank />
              </ProtectedRoute>
            }
          />
          <Route
            path="/logs"
            element={
              <ProtectedRoute>
                <Logs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reminders"
            element={
              <ProtectedRoute>
                <Reminders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/alert-settings"
            element={
              <ProtectedRoute>
                <AlertSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/communication"
            element={
              <ProtectedRoute>
                <Communication />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dna-ia"
            element={
              <ProtectedRoute>
                <DnaIA />
              </ProtectedRoute>
            }
          />
          <Route
            path="/assistente-ia"
            element={
              <ProtectedRoute>
                <AssistenteIA />
              </ProtectedRoute>
            }
          />

          <Route
            path="/aniversariantes"
            element={
              <ProtectedRoute>
                <Aniversariantes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/canva-redirect"
            element={
              <ProtectedRoute>
                <CanvaRedirect />
              </ProtectedRoute>
            }
          />
          <Route
            path="/campanhas"
            element={
              <ProtectedRoute>
                <Campanhas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/templates"
            element={
              <ProtectedRoute>
                <Templates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/usuarios"
            element={
              <ProtectedRoute>
                <Usuarios />
              </ProtectedRoute>
            }
          />
          <Route
            path="/relatorio-consolidado"
            element={
              <ProtectedRoute>
                <RelatorioConsolidado />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tabuada"
            element={
              <ProtectedRoute>
                <Tabuada />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz-milionario"
            element={
              <ProtectedRoute>
                <QuizMilionario />
              </ProtectedRoute>
            }
          />
          <Route
            path="/interclasse"
            element={
              <ProtectedRoute>
                <Interclasse />
              </ProtectedRoute>
            }
          />
          <Route
            path="/torneio-profissional"
            element={
              <ProtectedRoute>
                <TorneioProfissional />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mural-comunicados"
            element={
              <ProtectedRoute>
                <MuralComunicados />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documentos"
            element={
              <ProtectedRoute>
                <DocumentEditor />
              </ProtectedRoute>
            }
          />
          
          {/* DNA GO - Módulo de Retirada Segura */}
          <Route
            path="/dnago/painel"
            element={
              <ProtectedRoute>
                <DnaGoPainelSaida />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dnago/autorizados"
            element={
              <ProtectedRoute>
                <DnaGoAutorizados />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dnago/retiradas"
            element={
              <ProtectedRoute>
                <DnaGoRetiradas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dnago/vans"
            element={
              <ProtectedRoute>
                <DnaGoVans />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dnago/ocorrencias"
            element={
              <ProtectedRoute>
                <DnaGoOcorrencias />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dnago/dashboard"
            element={
              <ProtectedRoute>
                <DnaGoDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dnago/portaria"
            element={
              <ProtectedRoute>
                <DnaGoPainelPorteiro />
              </ProtectedRoute>
            }
          />
          
          {/* DNA CONNECT - Área Administrativa */}
          <Route
            path="/dnaconnect-admin"
            element={
              <ProtectedRoute>
                <DnaConnectAdmin />
              </ProtectedRoute>
            }
          />
          
          {/* AULAS EXTRAS 2026 - Administração */}
          <Route
            path="/aulas-extras-admin"
            element={
              <ProtectedRoute>
                <AulasExtrasAdmin />
              </ProtectedRoute>
            }
          />
          
          {/* DNA GROWTH ENGINE - CRM e Marketing */}
          <Route
            path="/growth"
            element={
              <ProtectedRoute>
                <DnaGrowthDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/growth/crm"
            element={
              <ProtectedRoute>
                <DnaCRM />
              </ProtectedRoute>
            }
          />
          <Route
            path="/growth/social"
            element={
              <ProtectedRoute>
                <DnaSocialAI />
              </ProtectedRoute>
            }
          />
          <Route
            path="/growth/atendimento"
            element={
              <ProtectedRoute>
                <DnaAtendimentoAI />
              </ProtectedRoute>
            }
          />
          <Route
            path="/growth/ads"
            element={
              <ProtectedRoute>
                <DnaAdsAI />
              </ProtectedRoute>
            }
          />
          <Route
            path="/growth/funnel"
            element={
              <ProtectedRoute>
                <DnaFunnelAI />
              </ProtectedRoute>
            }
          />
          <Route
            path="/growth/whatsapp"
            element={
              <ProtectedRoute>
                <DnaWhatsAppAI />
              </ProtectedRoute>
            }
          />
          <Route
            path="/growth/analytics"
            element={
              <ProtectedRoute>
                <DnaGrowthAI />
              </ProtectedRoute>
            }
          />
          <Route
            path="/growth/reputation"
            element={
              <ProtectedRoute>
                <DnaReputationAI />
              </ProtectedRoute>
            }
          />
          
          {/* CALENDÁRIO ESCOLAR */}
          <Route
            path="/calendario"
            element={
              <ProtectedRoute>
                <CalendarioEscolarAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendario-publico"
            element={<CalendarioEscolarPublico />}
          />
          
          {/* FISCAL - Módulo de Notas Fiscais NFS-e */}
          <Route
            path="/fiscal"
            element={
              <ProtectedRoute>
                <FiscalDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fiscal/config"
            element={
              <ProtectedRoute>
                <FiscalConfig />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fiscal/importacao-nfse"
            element={
              <ProtectedRoute>
                <FiscalImportacaoNfse />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fiscal/empresas"
            element={
              <ProtectedRoute>
                <FiscalEmpresas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fiscal/emissao"
            element={
              <ProtectedRoute>
                <FiscalEmissao />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fiscal/notas"
            element={
              <ProtectedRoute>
                <FiscalNotas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fiscal/relatorios"
            element={
              <ProtectedRoute>
                <FiscalRelatorios />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fiscal/integracao"
            element={
              <ProtectedRoute>
                <FiscalIntegracao />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fiscal/logs"
            element={
              <ProtectedRoute>
                <FiscalLogs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fiscal/erros"
            element={
              <ProtectedRoute>
                <FiscalErros />
              </ProtectedRoute>
            }
          />
          
          {/* TRIBUTÁRIO - Módulo de Apuração de Tributos */}
          <Route
            path="/tributario"
            element={
              <ProtectedRoute>
                <TributarioDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tributario/config"
            element={
              <ProtectedRoute>
                <TributarioConfig />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tributario/apuracao"
            element={
              <ProtectedRoute>
                <TributarioApuracao />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tributario/memoria"
            element={
              <ProtectedRoute>
                <TributarioMemoria />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tributario/simulacoes"
            element={
              <ProtectedRoute>
                <TributarioSimulacoes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tributario/relatorios"
            element={
              <ProtectedRoute>
                <TributarioRelatorios />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tributario/logs"
            element={
              <ProtectedRoute>
                <TributarioLogs />
              </ProtectedRoute>
            }
          />
          
          {/* EXECUTIVO - Dashboard Financeiro */}
          <Route
            path="/executivo"
            element={
              <ProtectedRoute>
                <ExecutivoDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/executivo/dre"
            element={
              <ProtectedRoute>
                <ExecutivoDRE />
              </ProtectedRoute>
            }
          />
          <Route
            path="/executivo/segmentos"
            element={
              <ProtectedRoute>
                <ExecutivoSegmentos />
              </ProtectedRoute>
            }
          />
          <Route
            path="/executivo/forecast"
            element={
              <ProtectedRoute>
                <ExecutivoForecast />
              </ProtectedRoute>
            }
          />
          
          {/* ESTRATÉGICO - Módulo de Inteligência de Negócios */}
          <Route
            path="/estrategico/expansao"
            element={
              <ProtectedRoute>
                <ExpansaoDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/estrategico/custos"
            element={
              <ProtectedRoute>
                <CustosDashboard />
              </ProtectedRoute>
            }
          />
          
          {/* DNA CONNECT - Portal das Famílias */}
          <Route path="/dna-sign/validar/:token" element={<DnaSignValidar />} />
          <Route path="/dna-sign/validar" element={<DnaSignValidar />} />
          <Route path="/familia/login" element={<DnaConnectLogin />} />
          <Route path="/enviodedocumentos" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><EnvioDocumentosPublico /></React.Suspense>} />
          <Route path="/familia/enviar-documentos/:token" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><RedirectEnvioDocumentos /></React.Suspense>} />
          <Route path="/familia/trocar-senha" element={<DnaConnectTrocarSenha />} />
          <Route path="/familia/redefinir-senha" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><RedefinirSenhaFamilia /></React.Suspense>} />
          <Route path="/familia/carteirinha/:studentId" element={<DnaConnectCarteirinha />} />
          <Route path="/familia" element={<DnaConnectLayout />}>
            <Route index element={<DnaConnectDashboard />} />
            <Route path="rematricula" element={<React.Suspense fallback={<div className='p-8'>Carregando...</div>}><Rematricula2027 /></React.Suspense>} />
            <Route path="filhos" element={<DnaConnectFilhos />} />
            <Route path="pedagogico" element={<DnaConnectPedagogico />} />
            <Route path="estudos" element={<DnaConnectEstudos />} />
            <Route path="semana-avaliacoes" element={<DnaConnectSemanaAvaliacoes />} />
            <Route path="financeiro" element={<DnaConnectFinanceiroPortal />} />
            <Route path="comunicacao" element={<DnaConnectComunicacao />} />
            <Route path="calendario" element={<DnaConnectCalendario />} />
            <Route path="documentos" element={<DnaConnectDocumentos />} />
            <Route path="convites" element={<Navigate to="/familia/eventos" replace />} />
            <Route path="eventos" element={<DnaConnectEventos />} />
            <Route path="dnago" element={<DnaConnectDnaGo />} />
            <Route path="aulas-extras" element={<AulasExtras />} />
            <Route path="perfil" element={<DnaConnectPerfil />} />
          </Route>
        </Routes>
        {isAuthenticated() && <DnaCommandLayer />}
        </PermV2Provider>
        </PermissoesProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
